import { connect } from 'react-redux';
import get from 'lodash/get';
import { actions, selectors } from 'app-webtech-core';
import { savePrivacyPolicy } from '../../../application/actions/';
import { PrivacyPolicyUpdateNotificationComponent } from '../../components/PrivacyPolicyUpdate/Notification';
import { userCountryCodeSelector } from '../../selectors/isUserAccountEnabled';

const mapStateToProps = (state) => ({
  countryCode: userCountryCodeSelector(state),
  marketingRegion: selectors.playbackSession.properties(state).marketingRegion,
  isEmbed: get(state, 'embed.enabled') || get(state, 'embed.corpEmbed'),
  hidePrivacyNotification: state.applicationinternal.hidePrivacyNotification,
});

const mapDispatchToProps = (dispatch) => ({
  policyAccepted: () => dispatch(actions.application.policyAccepted({ policyName: 'policy=ccpa' })),
  policyViewed: () => dispatch(actions.application.policyViewed({ policyName: 'policy=ccpa' })),
  policyViewedAccepted: () =>
    dispatch(actions.application.policyViewedAccepted({ policyName: 'policy=ccpa' })),
  updatePrivacyPolicy: (payload) => dispatch(savePrivacyPolicy(payload)),
});

export const PrivacyPolicyUpdateNotification = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrivacyPolicyUpdateNotificationComponent);
